import { useSelector } from 'react-redux';
import {
  selectApiBaseUrl,
  selectAppName,
  selectMqttUrl,
  selectSocketUrl,
} from '../store/slices/configSlice';

/** Centralized app config from Redux (env-backed). */
export default function useAppConfig() {
  const apiBaseUrl = useSelector(selectApiBaseUrl);
  const socketUrl = useSelector(selectSocketUrl);
  const appName = useSelector(selectAppName);
  const mqttUrl = useSelector(selectMqttUrl);

  return { apiBaseUrl, socketUrl, appName, mqttUrl };
}
